/*
 * @Author: Jason
 * @Date: 2019-10-15 17:32:50
 * @version:
 * @LastEditors: Jason
 * @LastEditTime: 2019-10-29 14:15:23
 * @Descripttion:
 */
import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'

Vue.use(Router)


export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', redirect: '/home' },
    { path: '*', redirect: '/home' },
    {
      path: '/home',   //  首页
      name: 'home',
      meta:{ isShowIcon:true },
      component: () => import('./views/Home.vue')
    },
    {
      path: '/personal',    // 个人中心页
      name: 'personal',
      meta:{ isShowIcon:true,isAuth:true },
      component: () => import('./views/personal.vue')
    },
    {
      path: '/login',    // 个人中心页
      name: 'login',
      meta:{ isShowIcon:true },
      component: () => import('./views/login.vue')
    },
    {
      path: '/service/pay',    // 支付结果页
      name: 'servicePay',
      meta:{ isShowIcon:true,isAuth:true },
      component: () => import('./views/service/pay.vue')
    },
    {
      path: '/service/result/:id?',    // 支付结果页
      name: 'serviceResult',
      meta:{ isShowIcon:false,isAuth:true },
      component: () => import('./views/service/result.vue')
    },
    {
      path: '/order',    // 订单列表页
      name: 'orderHome',
      meta:{ isShowIcon:true,isAuth:true },
      component: () => import('./views/order/home.vue')
    },
    {
      path: '/fwxz',    // 网点页面
      name: 'fwxz',
      meta:{ isShowIcon:true },
      component: () => import('./views/service/fwxz.vue')
    },
    {
      path: '/shop/list',    // 网点页面
      name: 'shopList',
      meta: { isShowIcon: true },
      component: () => import('./views/shop/list.vue')
    },
    {
      path: '/shop/city',    // 城市列表页面
      name: 'shopCity',
      meta:{ isShowIcon:true },
      component: () => import('./views/shop/city.vue')
    },
    {
      path: '/shop/nav',    // 城市导航
      name: 'shopNav',
      meta:{ isShowIcon:true },
      component: () => import('./views/shop/nav.vue')
    }
  ]

})
